import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M18 13H6c-.55 0-1-.45-1-1s.45-1 1-1h12c.55 0 1 .45 1 1s-.45 1-1 1z"
}), 'RemoveRounded');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/RemoveRounded.js
// module id = 5730
// module chunks = 2